"use client"

import { useEffect } from "react"
import { useSession } from "next-auth/react"
import { useTrack } from "@owlcat/app-shell"
import { trackOnce } from "@lib/analytics/fleet-events"

/**
 * Emits the fleet `signed_in` event once per browser session when the shop's
 * next-auth session appears (accounts SSO owns the login; the shop only sees
 * the result). sessionStorage one-shot → refetchOnWindowFocus can't re-fire it.
 */
export default function SignedInTracker() {
  const { status } = useSession()
  const track = useTrack()

  useEffect(() => {
    if (status !== "authenticated") return
    trackOnce(track, "signed_in", "signed_in", { provider: "sso", method: "sso" })
  }, [status, track])

  return null
}
